import React from "react";

export const UserRole = ({fill="#404040"}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.277"
      height="36.264"
      viewBox="0 0 29.277 36.264"
    >
      {/* <defs>
        <clipPath id="clip-path">
          <path
            id="Path_1362"
            data-name="Path 1362"
            d="M218,139.21h14.243v17.213H218Z"
            transform="translate(-218 -139.21)"
            fill=""
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <path
            id="Path_1364"
            data-name="Path 1364"
            d="M347,460h13.783v11.7H347Z"
            transform="translate(-347 -460)"
            fill={fill}
          />
        </clipPath>
      </defs> */}
      <g id="db71" transform="translate(-144.667 -139.21)">
        <g
          id="Group_1332"
          data-name="Group 1332"
          transform="translate(150.282 139.21)"
          // clip-path="url(#clip-path)"
        >
          <path
            id="Path_1361"
            data-name="Path 1361"
            d="M232.656,147.88a.55.55,0,0,0-.277-.186s0,0,0,0a2.508,2.508,0,0,0,.086-.965,1.979,1.979,0,0,1,.16-.555,1.32,1.32,0,0,0,.168-.706,1.548,1.548,0,0,0,0-.307c-.077-3.3-3.2-5.954-7.054-5.954-3.9,0-7.061,2.721-7.061,6.078,0,.112,0,.207.007.293l-.007.013.01.037c.018.276.061.42.133.465.127.43.1,1.075.191,1.633a.511.511,0,0,0-.19.15c-.216.293-.124.931-.124,1.374a1.473,1.473,0,0,0,1.2,1.623c.842,3.222,3.135,5.538,5.838,5.538s5-2.316,5.839-5.538a1.473,1.473,0,0,0,1.2-1.623c0-.443.092-1.08-.124-1.374Z"
            transform="translate(-218.624 -139.211)"
            fill={fill}
          />
        </g>
        <g
          id="Group_1333"
          data-name="Group 1333"
          transform="translate(160.16 163.774)"
          // clip-path="url(#clip-path-2)"
        >
          <path
            id="Path_1363"
            data-name="Path 1363"
            d="M360.948,470.24V460.05H347.19v10.19h4.749v.963H350.42v.543h7.3V471.2h-1.438v-.963Zm-13.093-.665V460.62h12.429v8.955Z"
            transform="translate(-347.175 -460.046)"
            fill={fill}
          />
        </g>
        <path
          id="Path_1365"
          data-name="Path 1365"
          d="M158.755,374.787v-8.075h11.164a22.359,22.359,0,0,0,.018-2.441,11.754,11.754,0,0,0-4.533-3.022v-.039a14.438,14.438,0,0,0-3.9-1.159,44.729,44.729,0,0,0-4.173,5.166,43.745,43.745,0,0,0-4.238-5.166,15.168,15.168,0,0,0-4.011,1.158v.039a18.569,18.569,0,0,0-4.393,3.022c-.109,2.28.127,5.32,1.1,6.623.881,1.174,2.364,3.405,9.17,3.834a7.309,7.309,0,0,0,.768.059v.01c.6.033,1.014.043,1.511.041s.907-.008,1.511-.041Z"
          transform="translate(0 -203.931)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
